import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

const orderManagementApi = {
  getOrderStats: () => {
    return request({
      method: HTTP_METHOD.GET,
      url: "v1/orders/stats",
      useBaseUrl2: true,
    });
  },
};

export default orderManagementApi;